'use client';

import { usePaymentReturn } from '@/hooks/usePaymentReturn';

export function PaymentReturnHandler() {
  usePaymentReturn();
  return null;
}